import React from 'react'
import img1 from 'images/new-icons/product-categories/make-up.png'
import img2 from 'images/new-icons/product-categories/serums.png'
import s from './ProductCategories.module.scss'
import useGetProductCategories from 'sdk/hooks/shop/useGetProductCategories'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'


const ProductCategories = () => {
    const {t} = useTranslation() as any
    const { data: categories, isLoading } = useGetProductCategories()
    const navigate = useNavigate()
    
    return (
        <div className={s.container}>
            {categories?.map((category) => (
                <div className={s.card} key={category.name} onClick={() => navigate(`/products-by-category/${category.id}`)} >
                    <div
                        className={s.card_title}
                        style={{ backgroundImage: `url(${category.image})` }}
                    >
                        {t(category.name)}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ProductCategories